import { DASHBOARD_PATH } from '@/common/main/config';
import useAuth from '@/auth/application/useAuth';
import { EUM_EMBED_USERS_PATH, isEmbeddedSession } from '@/common/application/embeddedMode';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const GuestGuard = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Keep sticky embed flag in sync on /login?embed=1 (Auth routes sit outside Layout).
    const embedded = isEmbeddedSession(location.search);
    if (isLoggedIn) {
      navigate(embedded ? EUM_EMBED_USERS_PATH : DASHBOARD_PATH, { replace: true });
    }
  }, [isLoggedIn, navigate, location.search]);

  return children;
};

export default GuestGuard;
